import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export async function callApi(id: string, action: 'SetAsDefault'): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/ShoppingCart/${action}/${id}`;
	return axios.post(url).toOptionalVoid();
}
